import { BaseDisplayer } from './BaseDisplayer';
import { ValueType } from '../FormatterTypes';
import { formatterBoolParamDef } from '../Utils/ParamUtils';
import { asString } from '../Utils/ValueUtils';
import { insertIntoString } from '../Utils/Other';

class TEDDisplayPostNr extends BaseDisplayer {
  public static getInstance(): TEDDisplayPostNr {
    return this.instance ? this.instance : (this.instance = new this());
  }

  private static instance: TEDDisplayPostNr;
  defaultParams(): string {
    return '';
  }

  defaultDisplayLength(params: string): number {
    if (formatterBoolParamDef('AllowForeign', params, this.defaultParams())) {
      return 0;
    } else {
      return 5;
    }
  }

  display(value: ValueType, displayText: boolean = true, params: string = '') {
    let valAsStr = asString(value) || '';

    // Only want to do something if we have 5 digits in a row
    const match = /^(SE-|S-)?((\d){5})$/.exec(valAsStr);

    if (displayText && match) {
      valAsStr = insertIntoString(
        ' ',
        valAsStr.replace(/\s/g, ''),
        match[1] ? 3 + match[1].length : 3
      );
    }

    return valAsStr;
  }
}

export { TEDDisplayPostNr };
